import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import { GetDetailList } from '@/api/MaintainDeliveryNote2';
import { SaveData, GetLastById, GetNextById } from '@/api/DeliveryCode';
import util from '@/libs/util';
import { GetReportID as _GetReportID } from '@/api/SysReportTpl';
export default {
  mounted: function mounted() {
    this.GetReportID();
    this.CREATORID = JSON.parse(util.cookies.get('userInfo')).USER_NAME;
  },
  data: function data() {
    return {
      formData: {
        DELIVERY_NO: null,
        // 送货单号
        DESCRIPTION: null,
        // 备注
        CREATETIME: null,
        // 创建日期
        VENDOR_CODE: null,
        // 供应商代码
        VENDOR_NAME: null // 供应商名称

      },
      // mode:'show',
      vendorOptions: [],
      selectLoading: false,
      CREATORID: null,
      isShowChangeVendorDialog: false,
      // 显示选择供应商dialog
      submitObj: null,
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      formDataRules: {
        DELIVERY_NO: [{
          required: true,
          message: '请选择送货单'
        }]
      },
      // printUrl: process.env.VUE_APP_PrintURL,
      templateID: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/OuterBoxLabelManagement', ['setOrderStatu'])), {}, {
    getData: function getData() {
      return this.formData;
    },
    // 设置数据
    setData: function setData(data) {
      this.formData.DELIVERY_NO = data.DELIVERY_NO;
      this.formData.CREATORID = data.CREATORID;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.DELIVERY_DATE = util.formatTime.transCommDate(data.DELIVERY_DATE);
      this.formData.VENDOR = data.VENDOR_NAME;
      this.formData.ARRIVAL_DATE = util.formatTime.transCommDate(data.ARRIVAL_DATE);
      this.formData.STATUS_Caption = data.STATUS_Caption;
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.ID = data.ID;
      this.submitObj = data;
    },
    // 上一张单据更新数据
    getBackUpdata: function getBackUpdata() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.formData);
                params = {
                  mst_id: _this.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context.next = 4;
                return GetNextById(params);

              case 4:
                res = _context.sent;
                console.log('上一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this.setData(res.data);

                    _this.$emit('cbNextOrder', res.data, res.data.STATUS);
                  } else {
                    _this.$message.warning('当前单据已为最前单据');
                  }
                } else {
                  _this.$message.warning('切换上一张单据失败');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 下一张单据更新数据
    nextOrderUpdata: function nextOrderUpdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.formData);
                params = {
                  mst_id: _this2.formData.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context2.next = 4;
                return GetLastById(params);

              case 4:
                res = _context2.sent;
                console.log(res);

                if (res.code === 0) {
                  if (res.data) {
                    _this2.setData(res.data);

                    _this2.$emit('cbNextOrder', res.data, res.data.STATUS);
                  } else {
                    _this2.$message.warning('当前单据已为最后单据');
                  }
                } else {
                  _this2.$message.warning('切换下一张单据失败');
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取打印模板id
    GetReportID: function GetReportID() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  billtype: 'BoxQrCode'
                };
                _context3.next = 3;
                return _GetReportID(params);

              case 3:
                res = _context3.sent;
                console.log('模板id', res);

                if (res.code === 0) {
                  _this3.templateID = res.data;
                } else {
                  _this3.$message.warning('获取打印模板失败');
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 组合打印外箱标签
    PrintOuterBoxLabel: function PrintOuterBoxLabel() {
      if (!this.templateID) {
        this.$message({
          showClose: true,
          message: this.$t('找不到条码打印模板！'),
          type: 'warning'
        });
        return;
      }

      var token = util.cookies.get('token');
      var dataurl = process.env.VUE_APP_API + "/DnBarcode/GetBoxCodeDetailPrintData?mst_id=".concat(this.submitObj.ID);
      var dxurl = this.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
      var url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(this.templateID, "&Token=").concat(token);
      util.open(url);
    },
    // 设置数据
    setFormData: function setFormData(selectRecords) {
      this.formData.DELIVERY_NO = selectRecords.DELIVERY_NO;
      this.formData.DESCRIPTION = selectRecords.DESCRIPTION;
      this.formData.CREATETIME = selectRecords.CREATETIME;
      this.formData.VENDOR_CODE = selectRecords.VENDOR_CODE;
      this.formData.VENDOR_NAME = selectRecords.VENDOR_NAME;
      this.formData.ID = selectRecords.ID;
      this.submitObj = selectRecords;
    },
    // 保存数据
    saveData: function saveData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res, order, params2, res2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.submitObj === null)) {
                  _context4.next = 3;
                  break;
                }

                _this4.$message.warning('请选择送货单');

                return _context4.abrupt("return");

              case 3:
                console.log(_this4.submitObj);
                params = {
                  MST_ID: _this4.submitObj.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context4.next = 7;
                return GetDetailList(params);

              case 7:
                res = _context4.sent;

                if (!(res.code === 0)) {
                  _context4.next = 21;
                  break;
                }

                order = res.data[0];

                if (!(order.PACKING_QTY === 0)) {
                  _context4.next = 13;
                  break;
                }

                _this4.$message.warning('该送货单装箱数量为0，不能生成外箱条码');

                return _context4.abrupt("return");

              case 13:
                params2 = {
                  ID: 0,
                  CREATETIME: _this4.submitObj.CREATETIME,
                  CREATORID: _this4.userInfo.USER_NAME,
                  DELETED: 0,
                  BILL_TYPE: 1,
                  DELIVERY_NO: _this4.submitObj.DELIVERY_NO,
                  ORGANIZE_ID: _this4.submitObj.ORGANIZE_ID,
                  STATUS: 0,
                  VENDOR_CODE: _this4.submitObj.VENDOR_CODE,
                  VENDOR_NAME: _this4.submitObj.VENDOR_NAME,
                  DESCRIPTION: _this4.submitObj.DESCRIPTION
                };
                _context4.next = 16;
                return SaveData(params2);

              case 16:
                res2 = _context4.sent;
                console.log('保存res2', res2);

                if (res2.code === 0) {
                  _this4.submitObj.ID = res2.data;

                  _this4.$emit('cbID', res2.data);

                  _this4.$message.success('保存成功，请点击生成标签');

                  _this4.setOrderStatu('orderShow');
                }

                _context4.next = 21;
                break;

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 关闭供应商选择dialog
    closeChangeVendorDialog: function closeChangeVendorDialog(value) {
      this.isShowChangeVendorDialog = value;
    },
    // 点击供应商选择
    handleChangeVendorBtn: function handleChangeVendorBtn() {
      this.isShowChangeVendorDialog = true;
    },
    saveOrder: function saveOrder() {
      var _this5 = this;

      console.log('this.formData', this.formData);
      this.$refs.formData.validate(function (bool) {
        if (bool === true) {
          _this5.Bus.emit('onSaveaddOrder', _this5.formData);
        }
      });
    },
    handleChange: function handleChange() {
      var _this6 = this;

      // console.log('选择',this.formData.VENDOR_CODE);
      this.vendorOptions.forEach(function (v) {
        if (v.value === _this6.formData.VENDOR_CODE) {
          _this6.formData.VENDOR_NAME = v.name;
        }
      });
    },
    // 下拉框输入供应商
    handleInputVendorSelect: function handleInputVendorSelect(value) {
      console.log(value);

      if (value !== '') {
        this.selectLoading = true;
        this.getVendorList(value);
      } else {}
    },
    // 点击供应商input
    handleVendorInput: function handleVendorInput() {
      console.log('123');
    },
    getVendorList: function getVendorList() {
      var _arguments = arguments,
          _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var Key, params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                Key = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Page: 1,
                  Limit: 20,
                  Key: Key
                };
                _context5.next = 4;
                return GetImsVendorLoadData(params);

              case 4:
                res = _context5.sent;
                console.log('供应商列表 res', res);
                _this7.selectLoading = false;

                if (res.code === 0) {
                  _this7.vendorOptions = res.data.Items.map(function (item) {
                    return {
                      key: item.Id,
                      value: item.Code,
                      label: item.Code + ' - ' + item.Name,
                      name: item.Name
                    };
                  });
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }),
  watch: {
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        var _this8 = this;

        // console.log('表头 单据操作状态 MaintainDeliveryNote2OrderState==>',nawValue);
        if (nawValue === 'orderShow') {} else if (nawValue === 'listShow') {
          this.$nextTick(function () {
            _this8.$refs.formData.resetFields();
          });

          for (var key in this.formData) {
            this.formData[key] = null;
          }
        } else {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState'])),
  beforeDestroy: function beforeDestroy() {
    this.Bus.off('onSaveOuterBoxLabelOrder');
    this.Bus.off('onSelectOrderForOuterBox');
  }
};